import { useEffect } from 'react';
// hooks
import useAuth from '../../hooks/useAuth';

export default function LoginWeb() {
  const { loginGuest } = useAuth();

  const handleLoginWeb = async () => {
    try {
      await loginGuest();
      
      window.location.href = "/";
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    handleLoginWeb();
  }, []);

  return (
    <></>
  );

}